import { render, staticRenderFns } from "./Videos.vue?vue&type=template&id=0dd80e4a&scoped=true&"
import script from "./Videos.vue?vue&type=script&lang=js&"
export * from "./Videos.vue?vue&type=script&lang=js&"
import style0 from "./Videos.vue?vue&type=style&index=0&id=0dd80e4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd80e4a",
  null
  
)

export default component.exports